/*! RUFFSY_NAV_FIX */
(function(){
  function paint(){
    var url='/pages/contact', label='Garantía 90 días';
    var drawer=document.querySelector('#menu-drawer .menu-drawer__navigation > .menu-drawer__menu');
    if(drawer && drawer.getAttribute('data-ruffsy-nav-fixed')!=='1'){
      drawer.setAttribute('data-ruffsy-nav-fixed','1');
      drawer.innerHTML='<li><a href="'+url+'" class="menu-drawer__menu-item list-menu__item link link--text focus-inset" data-ruffsy-nav="garantia">'+label+'</a></li>';
    }
    var desk=document.querySelector('.header__inline-menu > .list-menu');
    if(desk && desk.getAttribute('data-ruffsy-nav-fixed')!=='1'){
      desk.setAttribute('data-ruffsy-nav-fixed','1');
      desk.innerHTML='<li><a href="'+url+'" class="header__menu-item header__menu-item--main list-menu__item link link--text focus-inset" data-ruffsy-nav="garantia"><span>'+label+'</span></a></li>';
    }
    var acc=document.querySelector('#menu-drawer .menu-drawer__account');
    if(acc){
      var href=acc.getAttribute('href')||'';
      var text=/login|authentication/i.test(href)?'Iniciar sesión':'Mi cuenta';
      for(var i=0;i<acc.childNodes.length;i++){
        if(acc.childNodes[i].nodeType===3 && acc.childNodes[i].textContent.trim()){
          acc.childNodes[i].textContent=' '+text;
          break;
        }
      }
    }
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',paint); else paint();
  setTimeout(paint,100); setTimeout(paint,500);
})();

/**
 * Live market prices for Ruffsy Choose Package modal.
 * Cards = months; bottles = dose(porte) × months.
 * Variant price = one-time. Subscription = one-time / 1.3.
 */
(function () {
  'use strict';
  if (window.__ruffsyLivePrices) return;
  window.__ruffsyLivePrices = true;

  var VARIANT_BY_BOTTLES = {
    1: 52824338858260,
    2: 52824339972372,
    3: 52824340005140,
    4: 53128866103572,
    6: 53128866136340,
    9: 53128866169108
  };
  var hydrated = false;

  var ZERO_DEC = ['JPY', 'KRW', 'VND', 'CLP', 'COP', 'PYG', 'HUF'];
  var LOCALE_BY_CURRENCY = {
    COP: 'es-CO',
    MXN: 'es-MX',
    CLP: 'es-CL',
    ARS: 'es-AR',
    PEN: 'es-PE',
    UYU: 'es-UY',
    BOB: 'es-BO',
    CRC: 'es-CR',
    GTQ: 'es-GT',
    PYG: 'es-PY',
    USD: 'en-US',
    EUR: 'es-ES',
    GBP: 'en-GB',
    BRL: 'pt-BR',
    CAD: 'en-CA',
    JPY: 'ja-JP',
    KRW: 'ko-KR',
    VND: 'vi-VN',
    HUF: 'hu-HU'
  };

  function currencyCode() {
    return (
      (window.Shopify && Shopify.currency && Shopify.currency.active) ||
      (document.documentElement.getAttribute('data-currency')) ||
      ''
    );
  }

  function moneyLocale(code) {
    if (code && LOCALE_BY_CURRENCY[code]) return LOCALE_BY_CURRENCY[code];
    if (ZERO_DEC.indexOf(code) >= 0) return 'es-CO';
    return undefined;
  }

  function fmtGrouped(major, zeroDec, code) {
    try {
      if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
        return new Intl.NumberFormat(moneyLocale(code), {
          minimumFractionDigits: zeroDec ? 0 : 2,
          maximumFractionDigits: zeroDec ? 0 : 2,
          useGrouping: true
        }).format(major);
      }
    } catch (e) {}
    if (zeroDec) {
      return String(Math.round(major)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return Number(major).toFixed(2);
  }

  function fmt(cents) {
    var n = Math.round(Number(cents) || 0);
    var code = currencyCode();
    var zeroDec = ZERO_DEC.indexOf(code) >= 0;
    var amount = '';
    if (zeroDec) {
      amount = fmtGrouped(Math.round(n / 100), true, code);
    } else {
      var format =
        (window.Shopify && Shopify.money_format) ||
        (window.theme && theme.moneyFormat) ||
        '{{amount}}';
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        try {
          amount = String(Shopify.formatMoney(n, format))
            .replace(/\s*[A-Z]{3}\s*$/, '')
            .trim();
        } catch (e) {}
      }
      if (!amount) amount = fmtGrouped(n / 100, false, code);
    }
    if (code && amount.indexOf(code) === -1) amount = amount + ' ' + code;
    return amount;
  }

  function doseFromModal(modal) {
    var active = modal.querySelector('.rpkg-size.is-active');
    var n = active
      ? parseInt(active.getAttribute('data-dose-per-day') || '1', 10)
      : 1;
    return !n || n < 1 ? 1 : n;
  }

  function apply(product) {
    if (!product || !product.variants) return;
    var byId = {};
    product.variants.forEach(function (v) {
      byId[String(v.id)] = v;
    });
    document.querySelectorAll('.rpkg-cards').forEach(function (wrap) {
      var modal = wrap.closest('.rpkg-modal') || wrap.parentElement;
      var dose = doseFromModal(modal || document);
      wrap.querySelectorAll('.rpkg-card[data-months]').forEach(function (card) {
        var months = Number(card.getAttribute('data-months') || '1') || 1;
        var bottles = dose * months;
        var vid = VARIANT_BY_BOTTLES[bottles];
        var v = vid ? byId[String(vid)] : null;
        if (!v || !v.price) return;
        var one = Math.round(Number(v.price) || 0);
        var sub = Math.round((one * 100) / 130);
        card.setAttribute('data-qty', String(bottles));
        card.setAttribute('data-one-cents', String(one));
        card.setAttribute('data-sub-cents', String(sub));
        card.dataset.oneNow = fmt(one);
        card.dataset.subNow = fmt(sub);
        card.dataset.subWas = fmt(one);
        card.dataset.oneWas = '';
      });
    });
    hydrated = true;
    if (typeof window.__ruffsyPkgSync === 'function') {
      window.__ruffsyPkgSync();
    }
  }

  function run(force) {
    if (hydrated && !force) return;
    var handle =
      (window.meta && meta.product && meta.product.handle) ||
      (document.querySelector('[data-product-handle]') &&
        document
          .querySelector('[data-product-handle]')
          .getAttribute('data-product-handle')) ||
      (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1];
    if (!handle) return;
    if (!document.querySelector('.rpkg-card[data-months]')) return;
    fetch('/products/' + handle + '.js?v=' + Date.now(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(apply)
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(false);
    });
  } else {
    run(false);
  }
  document.addEventListener('click', function (e) {
    if (
      e.target &&
      e.target.closest &&
      e.target.closest('[data-rpkg-open], .rpkg-toggle__btn, .rpkg-card, .rpkg-size')
    ) {
      if (typeof window.__ruffsyPkgSync === 'function') {
        setTimeout(function () {
          window.__ruffsyPkgSync();
        }, 0);
      } else if (!hydrated) {
        run(false);
      }
    }
  });
})();
